export default {
    path: '/superAdmin',
    name: 'superAdmin',
    meta: {
        title: '超级管理员端'
    },
    component: resolve => require(['@/views/boss.vue'], resolve),
    redirect: '/superAdmin/home', 
    children: [
        {
            path: '/superAdmin/home',
            name: 'superAdmin',
            meta: [{
                path: '/superAdmin/superAdmin',
                title: '实时监测',
                color: "#f2f2f2"
            }],
            component: resolve => require(['@/views/superAdmin/index.vue'], resolve),
        }, 
        {
            path: '/superAdmin/deviceCntNum',
            name: 'deviceCntNum',
            meta: [{
                path: '/superAdmin/deviceCntNum',
                title: '监测仪总数',
                color: "#f2f2f2"
            }],
            component: resolve => require(['@/views/superAdmin/deviceCntNum.vue'], resolve),
        }
    ],
}